import { createAction } from '@reduxjs/toolkit'

import type {
  TCreateCustomEndpointsBulkResponse,
  TUpdateCustomEndpointResponse
} from '@homepal/api-contract'
import { CustomEndpoint, DynamicsEntitySet } from 'types/GlobalCustomEndpoint'

// tryGetAllCustomEndpoints
export const getAll = createAction('get_custom_endpoints')
export const getAllSuccess = createAction<{ data: CustomEndpoint[] }>(
  'get_custom_endpoints_success'
)
export const getAllFailed = createAction('get_custom_endpoints_failed')

// tryCreateCustomEndpoint
export const create = createAction('create_custom_endpoint')
export const createSuccess = createAction<{ data: CustomEndpoint }>(
  'create_custom_endpoint_success'
)
export const createFailed = createAction('create_custom_endpoint_failed')

// tryCreateCustomEndpoints
export const createMany = createAction('create_custom_endpoints')
export const createManySuccess =
  createAction<TCreateCustomEndpointsBulkResponse>(
    'create_custom_endpoints_success'
  )
export const createManyFailed = createAction('create_custom_endpoints_failed')

// tryUpdateCustomEndpoint
export const update = createAction('update_custom_endpoint')
export const updateSuccess = createAction<TUpdateCustomEndpointResponse>(
  'update_custom_endpoint_success'
)
export const updateFailed = createAction('update_custom_endpoint_failed')

// tryDeleteCustomEndpoint
export const destroy = createAction('destroy_custom_endpoint')
export const destroySuccess = createAction<{ id: string }>(
  'destroy_custom_endpoint_success'
)
export const destroyFailed = createAction('destroy_custom_endpoint_failed')

// tryGetAllDynamicsEntitySets
export const getEntitySets = createAction('get_dynamics_entity_sets')
export const getEntitySetsSuccess = createAction<{
  activeSourceId: string
  data: DynamicsEntitySet[]
}>('get_dynamics_entity_sets_success')
export const getEntitySetsFailed = createAction(
  'get_dynamics_entity_sets_failed'
)
